import { render, staticRenderFns } from "./VPlanCard.vue?vue&type=template&id=4765c357&scoped=true&"
import script from "./VPlanCard.vue?vue&type=script&lang=js&"
export * from "./VPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./VPlanCard.vue?vue&type=style&index=0&id=4765c357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765c357",
  null
  
)

export default component.exports